const msgComment = {
  namespaced: true,
  state: {
    msgData: "",
    filePath: ""
  },

  mutations: {
    // 多条评论数据合并
    SET_MERGE(state, data) {
      state.msgData += data;
    },
    SET_FILE(state, data) {
      state.filePath += data;
    },
    RESET(state) {
      state.msgData = "";
      state.filePath = "";
    }
  },
  actions: {},
  getters: {}
};

export default msgComment;
